/**
 * Registers the 'statusmap' directive with the provided AngularJS module.
 * This directive is used to render a status map component.
 * 
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerStatusmapDirective(module) {
    module.directive('statusmap', function() {
        return {
            restrict: 'E', // Restricts the directive to be used as an element only.
            templateUrl: '/views/ib/modules/statusmap/StatusMapDirective.html' // Path to the template file.
        };
    });
}